export default __webpack_public_path__ + "static/media/francheville23.86b9f091.jpg";